<script lang="ts">
	/** ############################################################
	 * This is the 404 (specifically "route not found") error page.
	 * ############################################################# */
	import { goto } from "$app/navigation";
	import { page } from "$app/stores";
	import { LOCATION_PROPS } from "$lib/serv/locations";
	import { verticals } from "$lib/def/verticals";
	import Error from "$lib/ui/shared/Error.svelte";
	import { query } from "$lib/util/url";

	// TODO: Best way to include nav on this page (do we want to?)?  The more specific +layout
	// files don't apply to it because it lives outside their folders.

	// TODO: Where is the best place to get location, vertical + store props?  Needed for the 
	// "Browse XXX" button text and also in order to construct the home url
	let verticalSlug = $page.url.searchParams.get("vertical");
	let vertical = (verticals.find(({slug}) => slug === verticalSlug) ?? verticals[0]).title;

	// let verticalSlug: string | undefined;
	// let vertical: string;
	// landingItemsParams$.pipe(take(1)).subscribe({
	// 	next(li) {
	// 		verticalSlug = li.vertical;
	// 		vertical = (verticals.find(({slug}) => slug === verticalSlug) ?? verticals[0]).title;
	// 	}
	// });

	if ($page.error) console.warn($page.error.message);
</script>

<Error
	title="We lost this page"
	description="We can't seem to find what you're looking for."
	showInput={false}
	extra={$page.error?.message ?? ''}
	buttonText={`Browse ${vertical}`}
	buttonHref={query($page.url).keep(...LOCATION_PROPS, "vertical", "store").toUrl('/')}
/>